<template>
  <div :class="['widget-common', 'widget-full-height', sizeClass]">
    <div class="widget-title">
      <div class="d-flex align-items-baseline">
        WORK TIME CLASSIFICATION
        <i
          v-tooltip="tooltipOptions"
          class="hi hi-info-filled ml-5"
          :title="titleTooltip"
        ></i>
      </div>
    </div>

    <div class="widget-body">
      <div class="with-data">
        <div class="d-flex">
          <div class="core-work mt-15">
            <strong>{{ coreWorkPercentage }}%</strong>
            <span>Core work</span>
          </div>
        </div>
        <AppChartLineStacked
          class="mt-20"
          :values="workTimeClassificationChartData"
          has-tooltips
        />
        <AppChartLegend
          class="dashboard-widget"
          :values="workTimeClassificationLegendData"
          orientation="vertical"
        />
      </div>
    </div>
    <div class="widget-footer-bordered">
      <InsightsBenchmarksAverages
        :averages="benchmarksAverages"
        :is-loading="false"
        :pins="benchmarkPins"
        :widget-name="title"
      />
    </div>
  </div>
</template>

<script>
import AppChartLineStacked from '~/components/AppChartLineStacked.vue';
import AppChartLegend from '~/components/AppChartLegend.vue';
import InsightsBenchmarksAverages from '~/components/insights/InsightsBenchmarksAverages.vue';

export default {
  name: 'WorkTimeClassificationWidget',
  components: {
    AppChartLineStacked,
    AppChartLegend,
    InsightsBenchmarksAverages,
  },
  props: {
    workTimeClassification: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    titleTooltip:
      'Average work time proficiency for the selected time period, calculated based on the classification of accessed apps & URLs. There are 3 classifications: Core work, Non-core work and Unproductive work. To edit them, go to Settings > Insights',
    tooltipOptions: Object.freeze({
      placement: 'top',
      html: true,
    }),
    title: 'Work Time Classification',
    sizeClass: 'widget-medium',
    remoteVsOffice: false,
  }),
  computed: {
    coreWorkPercentage() {
      return this.workTimeClassification?.find((item) => item.key === 'core')?.value || 0;
    },
    benchmarksAverages() {
      return this.workTimeClassification?.find((item) => item.key === 'core')?.benchmarks || {};
    },
    benchmarkPins() {
      return [{ key: 'standard', value: this.coreWorkPercentage }];
    },
    workTimeClassificationLegendData() {
      return this.workTimeClassification?.map((label) => ({ ...label, tooltip: label.tooltip }));
    },
    workTimeClassificationChartData() {
      return this.workTimeClassification?.map((data) => {
        let tooltip = '<ul class="list-unstyled m-0 text-left">';

        tooltip += Object.entries(data.tools)
          .map(([key, value]) => `<li>${key}: ${value}%</li>`)
          .join('');
        tooltip += '</ul>';

        return {
          key: data.key,
          label: data.label,
          value: data.value,
          tools: data.tools,
          tooltip,
        };
      });
    },
  },
  beforeMount() {
    this.$store = { state: { filters: {}, num_active_smart_notifs: 0 } };
  },
};
</script>
